import React from 'react';

import { MenuDivider, MenuWrapper } from './styles';
import MenuItem from './MenuItem';
import SubMenu from './SubMenu';

type ComponentProps = {
  children: React.ReactNode;
};

type MenuType = {
  Divider: typeof MenuDivider;
  Item: typeof MenuItem;
  SubMenu: typeof SubMenu;
} & React.FC<ComponentProps>;

const Menu: MenuType = ({ children }: ComponentProps) => (
  <MenuWrapper>{children}</MenuWrapper>
);

Menu.Divider = MenuDivider;
Menu.Item = MenuItem;
Menu.SubMenu = SubMenu;

export default Menu;
